import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router'

import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

import UsuarioCentros from './usuario_centros';
import UsuarioActionButtons from './usuario_action_buttons';

//actions:
import { navigate, setSaveState, openDialog } from '../../actions';
import { getAllCentros } from '../../actions/centro_actions';
import { getUsuarioDetalle, modifyFieldDetalleUsuario, addNewUsuario } from '../../actions/perfiles_usuario_actions';

//for the select options:


import * as config from '../../constants/configuration';

const styles = theme => ({
    toolbar: {
        display: 'block',
        minHeight: 112,
        marginBottom: 15,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    formRight: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 0 5px 20px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    formSelect: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 0 5px 20px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    formComent: {
        display: 'flex',
        justifyContent: 'center',
        margin: '10px 0 5px 25px',
        width: 520,
        minWidth: 120,
    },
    grid: {
        padding: '0 12px',
        width: '100%',
    },
    buttonAtras: {
        margin: '0 0 10px 16px',
        height: 40,
        width: 123,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    centroSelect: {
        maxWidth: 240
    },
    modeloSelect: {
        marginRight: 20,
        maxWidth: 240
    },
    buttonIcon: {
        marginLeft: theme.spacing(2),
        borderRadius: 0,
        border: 'none',
        boxShadow: 'none',
        height: 48
    },
});

class UsuarioEdit extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.match.params.id,
            codigoUsuario: '',
            password: '',
            nombre: '',
            centro: '',
            centroId: -1,
            activo: true,
        };
    };

    componentDidMount() {
        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getAllCentros();

    };

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (prevProps.centros !== this.props.centros) {
            if (this.props.match.params.id === '-1') {
                this.props.addNewUsuario(this.props.centroDiaSelected.centro.id);
            }
            else {
                this.props.getUsuarioDetalle(this.props.match.params.id);
            }
        }
        else if (prevProps.usuarioDetalles !== this.props.usuarioDetalles) {
            this.setState({
                id: this.props.usuarioDetalles.id,
                codigoUsuario: this.props.usuarioDetalles.codigoUsuario,
                password: this.props.usuarioDetalles.password,
                nombre: this.props.usuarioDetalles.nombre,
                centro: this.props.centros.find(c => c.id === this.props.usuarioDetalles.centroId).centro,
                centroId: this.props.usuarioDetalles.centroId,
                activo: this.props.usuarioDetalles.activo,
            });

            //if ((prevProps.updated !== this.props.updated) && this.props.updated) this.props.navigate("mae_auxiliares_perfiles_usuario");

        }


    };

    //textfield
    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };


    //checkbox:
    handleBooleanChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.checked });
    };


    onBlur = (event, field) => {

        const value = field === 'centroId' ? parseInt(this.state[field]) : this.state[field];

        if (this.props.usuarioDetalles[field] !== value) {
            this.props.setSaveState(true);
            this.props.modifyFieldDetalleUsuario(field, value);
        }

    };

    onBlurCheckBox = (event, field) => {

        let value = event.target.checked;

        if (value === 'true') value = true;
        else if (value === 'false') value = false;

        this.props.setSaveState(true);
        this.props.modifyFieldDetalleUsuario(field, value);
    };


    goBack = () => {
        if (this.props.saveState.pending) {
            this.props.openDialog('ConfirmationDialog', {
                message: 'Existen cambios no guardados. Desea abandonar la sección y perder los cambios?',
                acceptHandler: () => {
                    this.props.setSaveState(false);
                    this.props.navigate("mae_auxiliares_perfil_usuario");
                }
            }, 'left-drawer-confirmation-message', false, 'sm');
        }
        else {
            this.props.navigate("mae_auxiliares_perfiles_usuario");
        }
    }


    render() {

        const { classes } = this.props;

        return (!this.props.isLoading && this.props.centros ?
            <div>
                <div className={classes.toolbar} />
                <Grid container spacing={24}>
                    <form>
                        <IconButton className={classes.buttonIcon} variant="contained" color="secondary" onClick={this.goBack}> <Icon>keyboard_backspace</Icon></IconButton>

                        <div className={classes.containerPair}>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    id={'descr'}
                                    label={'Nombre'}
                                    placeholder={'Nombre'}
                                    autoFocus
                                    value={this.state.nombre}
                                    onChange={(event) => this.handleValueChange(event, 'nombre')}
                                    onBlur={(event) => this.onBlur(event, 'nombre')}
                                    onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'nombre') }; }}
                                />
                            </FormControl>

                            {this.props.kd === undefined ? (
                                <FormControl className={classes.centroSelect}>
                                    <InputLabel htmlFor="input-centros">Centro</InputLabel>
                                    <Select
                                        native
                                        value={this.state.centroId}
                                        onChange={(event) => this.handleValueChange(event, 'centroId')}
                                        onBlur={(event) => this.onBlur(event, 'centroId')}
                                        input={<Input id="input-centros" />}
                                        name="centroId"
                                    >
                                        {this.props.centros.map(centro => {
                                            return (<option key={'centro_' + centro.id} value={centro.id}>{centro.centro}</option>)
                                        })}
                                    </Select>
                                </FormControl>
                            ) : (
                                ''
                            )
                            }
                        </div>


                        <div className={classes.containerPair}>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    id={'codigoUsuario'}
                                    label={'Código de usuario'}
                                    placeholder={'Usuario'}
                                    value={this.state.codigoUsuario}
                                    onChange={(event) => this.handleValueChange(event, 'codigoUsuario')}
                                    onBlur={(event) => this.onBlur(event, 'codigoUsuario')}
                                    onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'codigoUsuario') }; }}
                                />
                            </FormControl>

                            <FormControl className={classes.formRight}>
                                <TextField
                                    id={'password'}
                                    label={'Password'}
                                    placeholder={'Password'}
                                    value={this.props.kd === undefined ? this.state.password : '******'}
                                    onChange={(event) => this.handleValueChange(event, 'password')}
                                    onBlur={(event) => this.onBlur(event, 'password')}
                                    onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e, 'password') }; }}
                                />
                            </FormControl>

                        </div>

                        <div className={classes.containerPair} style={{ marginTop: 15 }}>
                            <FormControl className={classes.formControl}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.activo}
                                            onChange={event => this.handleBooleanChange(event, 'activo')}
                                            onBlur={(event) => this.onBlurCheckBox(event, 'activo')}
                                            onKeyPress={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.onBlur(e) }; }}
                                            color="primary"
                                        />
                                    }
                                    label="Activo"
                                />
                            </FormControl>

                        </div>
                    </form>
                    {this.props.kd === undefined ? (
                        <div className={classes.grid}>
                            <UsuarioCentros id={parseInt(this.props.match.params.id)} />
                        </div>
                    ) : (
                        ''
                    )}
                    <div className={classes.grid}>
                        <UsuarioActionButtons id={parseInt(this.props.match.params.id)} backHandler={this.goBack} />
                    </div>
                </Grid>
            </div>
            : ''
        );

    };

};

UsuarioEdit.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    usuarioDetalles: PropTypes.object,
    updated: PropTypes.bool.isRequired,

};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        usuarioDetalles: state.usuarioDetalles.usuarioDetalles,
        updated: state.usuarioDetalles.updated,
        centros: state.centros.centros,
        centroDiaSelected: state.centroDiaSelected,
        saveState: state.saveState,
        kd: state.userProfile.kd,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        navigate,
        setSaveState,
        getAllCentros,
        getUsuarioDetalle,
        modifyFieldDetalleUsuario,
        addNewUsuario,
        openDialog
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(styles, { withTheme: true })(UsuarioEdit)));